import React from 'react';
import Check from '../assets/icons/Check';

const StepProgressIndicator = ({ step }) => {
  const totalVisibleSteps = 3;

  if (step > totalVisibleSteps) return null;

  const getColor = (index) => {
    return index + 1 < step ? '#d3e205' : '#333333';
  };

  const getIcon = (index) => {
    const currentStep = index + 1;

    if (currentStep < step) {
      return <Check style={styles.checkIcon} />;
    } else {
      return (
        <span style={currentStep === step ? styles.currentStepText : styles.inactiveStepText}>
          {currentStep}
        </span>
      );
    }
  };

  const labels = [
    'Marka i model vozila',
    'Unesi opis traženog dela',
    'Oglasi svoj zahtev',
  ];

  return (
    <div style={styles.wrapper}>
      {[...Array(totalVisibleSteps)].map((_, index) => (
        <React.Fragment key={index}>
          <div style={styles.stepWrapper}>
            <div style={styles.circleAndLabelContainer}>
              <div
                style={{
                  ...styles.circle,
                  backgroundColor: getColor(index),
                }}
              >
                {getIcon(index)}
              </div>
              <div style={styles.labelContainer}>
                <div style={styles.label}>{labels[index]}</div>
              </div>
            </div>
          </div>
          {index < totalVisibleSteps - 1 && (
            <div style={styles.line} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepProgressIndicator;

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 40,
    marginTop: 40,
    width: '100%',
  },
  stepWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100px',
    width: 'auto',
    marginTop: 10,
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '100%',
  },
  circleAndLabelContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    width: 'auto',
    marginTop: 10,
  },
  circle: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: 14,
  },
  line: {
    width: 200,
    height: 2,
    marginTop: 10,
    backgroundColor: '#888888',
  },
  label: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '14px',
    color: '#ffffff',
    marginTop: 10,
    textAlign: 'center',
    lineHeight: '16px',
    fontWeight: 'bold',
    maxWidth: '100px',
  },
  checkIcon: {
    color: 'black',
    width: 18,
    height: 18,
  },
  currentStepText: {
    color: '#ffffff',
  },
  inactiveStepText: {
    color: '#888888',
  },
};
